<template>
	<div class="page">
		<video ref="vid" playsInline autoplay="autoplay" muted loop>
			<source v-if="$root.isMobile" src="/videos/mobile_stars.mp4" type="video/mp4">
			<source v-else src="/videos/desktop_stars.mp4" type="video/mp4">
			Your browser does not support the video tag.
		</video>
		<div class="page-inner ">
			<transition name="bounce">
				<div v-if="bounce" :class="['button-container', {'button-bounce': buttonpressed === 1}, {'button-pulse': buttonpulse}]">
					<a :href="url" target="_blank">
						<button class="button1" @click="gaEvent('Results Page', 'Clicked Email Me My Bedtime Rhyme'); pressed(1)">
							
						</button>
					</a>
					<div class="button-title">Email me my<br>bedtime rhyme</div>
				</div>
			</transition>
			<transition name="bounce">
				<div v-if="bounce" :class="['button-container', {'button-bounce': buttonpressed === 2}, {'button-pulse': buttonpulse}]">
					<a :href="listenOnSpotifyAuthUrl" target="_blank" @click="listenOnSpotify()">
						<button class="button2" @click="pressed(2)">
							
						</button>
					</a>
					<div class="button-title">continue to<br>my sleepmix</div>
				</div>
			</transition>
			<transition name="bounce">
				<div v-if="bounce" :class="['button-container', {'button-bounce': buttonpressed === 3}, {'button-pulse': buttonpulse}]">
					<button class="button3" @click="revealSocials(); gaEvent('Results Page', 'Clicked Share My Sleepmix'); pressed(3)">						
						<transition name="fade">
							<div v-if="socials" class="socials-containner">
								<img @click="facebookShare()" src="/images/facebook.svg" alt="Facebook" />
								<img @click="twitterShare()" src="/images/twitter.svg" alt="Twitter" />
							</div>
						</transition>
					</button>
					<div class="button-title">Share my<br>sleepmix</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import { spotifyClientID } from '../constants.js';

export default {
	data() {
		return {
			result: this.$route.params.result,
			url: localStorage.getItem("sleepstory") === '1' ? 'https://x.ex.seek.com.au/ats/show.aspx?cr=100334&fm=69' : 'https://x.ex.seek.com.au/ats/show.aspx?cr=100334&fm=73',
			trackIds: localStorage.getItem('track_ids'),
			listenOnSpotifyAuthUrl: `https://accounts.spotify.com/authorize?client_id=${spotifyClientID}&response_type=code&redirect_uri=${window.location.protocol}//${window.location.hostname}/spotify/login-return&scope=playlist-modify-public%20ugc-image-upload`,
			bounce: false,
			buttonpressed: 0,
			socials: false,
			shareCopy: 'Create your personalised Sleepmix',
			buttonpulse: true
		};
	},
	mounted() {
		this.bounce = true;
	},
	methods: {
		listenOnSpotify() {
			this.gaEvent('Results Page', 'Clicked Continue to Sleepmix');
			localStorage.setItem('listenRedirect', true);
		},
		facebookShare() {
			this.gaEvent('Results Page', 'Clicked Share on Facebook');
			let url = `https://www.facebook.com/sharer/sharer.php?u=${window.location.origin}`;
			this.$root.popupCenter(url, 'Facebook', 560, 560);
		},
		twitterShare() {
			this.gaEvent('Results Page', 'Clicked Share on Twitter');
			let url = `https://twitter.com/intent/tweet?text=${window.location.origin}`;
			this.$root.popupCenter(url, 'Twitter', 630, 455);
		},
		pressed(button) {
			this.buttonpulse = false;
			setTimeout(() => {
				this.buttonpulse = true;
			},1000)
			this.buttonpressed = button;
		},
		revealSocials() {
			this.socials = true;
		}
	}
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity 1s;
}
.fade-enter, .fade-leave {
	opacity: 0;
}

.page-inner {
	justify-content: center;
}

.desktop .page-inner {
    flex-flow: wrap;
}

.button-title {
    text-align: center;
    text-transform: uppercase;

	margin: auto;
}

.mobile .button-container {
	margin-bottom: 1rem;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.desktop .button-title {
    height: 6rem;
    position: absolute;
    transform: translateY(9.5rem);
}

.mobile .button-title {
	font-size: 2rem;
}

button {
	display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease-in-out;
    border-radius: 1rem;
	box-shadow: 0px 2px 3px 0px grey;
	margin: 2rem 1rem 1rem;
    height: 8rem;
    width: 14rem;
	background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
	padding: 0;
}

.button1 {
    background-image: url(/images/save.png);
}
.button2 {
    background-image: url(/images/continue.png);
}
.button3 {
    background-image: url(/images/share.png);
}

.desktop .button-container {
	display: flex;
	flex-direction: column;
	justify-content: center;
    align-items: center;
}

.button-container {
	position: relative;
}

.desktop button {
    width: 18rem;
    height: 12rem;
}

button:first-child {
	margin-top: 0;
}

.socials-containner {
	width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #00000075;
    border-radius: 1rem;
	top: 0;
}

.socials-containner img {
    width: 3rem;
    height: 3rem;
    margin: 1rem;
    filter: invert(1);
    cursor: pointer;
    transition: all 0.3s;
}

.socials-containner img:hover {
    transform: scale(1.05);
}
</style>